<template>
  <table :id="tableId" class="display table table-striped table-bordered" style="width:100%; text-align: center;">
    <thead>
      <tr>
        <th>No.</th>
        <th>Push Notification Message</th>
        <th>Created By</th>
        <th>Created At</th>
        <th>Image</th>
        <th>Link</th>
        <th>Period</th>
        <th>Frequency</th>
        <th>Time</th>
        <th>Action</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(advert, index) in adverts" :key="advert.id">
        <td>{{ index + 1 }}</td>
        <td>{{ advert.content }}</td>
        <td>{{ advert.created_by }}</td>
        <td>{{ advert.created_at_formatted }}</td>
        <td>
          <img :src="advert.image_link + '?' + new Date().getTime()" class="img-fluid" width="100" />
        </td>
        <td>{{ advert.link }}</td>
        <td>{{ advert.period }}</td>
        <td>{{ advert.frequency_text }}</td>
        <td>{{ advert.time_formatted }}</td>
        <td>
          <div>
            <button :disabled="btnStatus" type="button" class="btn btn-rounded btn-block" 
              :class="`${advert.status ? 'btn-success' : 'btn-danger'}`" 
              @click="handleChangeStatus(advert.id)">
              {{ advert.status ? 'Deactivate' : 'Activate' }}
            </button>

            <router-link :to="editAdvert(advert.id)" type="button" class="btn btn-success btn-rounded btn-block">
              Edit Details
            </router-link>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  props: {
    adverts: {
      type: Array,
      required: true
    },
    tableId: {
      type: String,
      required: false,
      default: '_table_advert'
    },
    btnStatus: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  data() {
    return {
      dataTable: null
    }
  },

  watch: {
    adverts: {
      handler() {
        this.$nextTick(() => {
          if (this.dataTable) {
            this.destroyDatatable();
          }
          this.initializeDataTable();
        });
      },
      deep: true
    }
  },

  methods: {
    handleChangeStatus(id) {
      this.$emit('changeData', id)
    },

    editAdvert(advert_id) {
      return `/marketing/advert/update/${advert_id}`;
    },

    destroyDatatable() {
      if (this.dataTable) {
        this.dataTable.destroy();
        this.dataTable = null;
      }
    },

    initializeDataTable() {
      $(`#${this.tableId}`).DataTable({
        pageLength: 5,
        dom: "Bfrtip",
        buttons: [
          {
            extend: "excelHtml5",
            exportOptions: {
              columns: [0, 1, 2, 3, 4, 5]
            }
          },
          {
            extend: "pdfHtml5",
            exportOptions: {
              columns: [0, 1, 2, 3, 4, 5]
            }
          }
        ]
      });
    },

    reinitializeDataTable() {
      this.destroyDatatable();
      this.initializeDataTable();
    }
  },

  mounted() {
    this.$nextTick(() => {
      // this.reinitializeDataTable();
    });
  },

  beforeDestroy() {
    if (this.dataTable) {
      this.dataTable.destroy();
    }
  }
}
</script>
